<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M16.52 4.106a1.369 1.369 0 00-1.061.002L5.385 8.364a.817.817 0 00-.225.141A1.628 1.628 0 004 10.065V22.26a1.63 1.63 0 001.025 1.512l9.546 3.828.606.243a2.19 2.19 0 001.61.007l.628-.245 9.546-3.725A1.63 1.63 0 0028 22.363V10.064a1.628 1.628 0 00-1.054-1.523.816.816 0 00-.265-.178L16.52 4.106zm.298 9.568l4.84-1.87 3.07-1.134 1.636-.606v12.299l-7.91 3.087-1.636.638V13.674zm-5.962-1.68l4.326 1.686v12.408l-1.636-.656-7.91-3.172V10.064l1.637.606 3.583 1.325zm10.221-1.713l3.103-1.198-8.188-3.43-8.12 3.43 3.567 1.39 4.313 1.594c.086.033.17.072.248.117a1.76 1.76 0 01.248-.117l4.83-1.786z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'objectsBoxOutline'
}
</script>
